import type { MediaMetadata, MediaType } from "./mediaStore";

export class MediaUtils {
  static async collectMetadata(file: File): Promise<MediaMetadata> {
    if (file.type.startsWith("image") && file.type !== "image/svg+xml") {
      return this.collectImageMetadata(file, "image");
    } else if (file.type === "image/svg+xml") {
      return this.collectSvgMetadata(file);
    } else if (file.type.startsWith("video")) {
      return this.collectVideoMetadata(file);
    } else {
      const type: MediaType = file.type.startsWith("image") ? "image" : "video";
      return this.collectBasicMetadata(file, type);
    }
  }

  private static collectImageMetadata(
    file: File,
    type: MediaType
  ): Promise<MediaMetadata> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        resolve({
          type,
          mimeType: file.type,
          size: file.size,
          width: img.width,
          height: img.height,
          name: file.name,
        });
        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        resolve({
          type,
          mimeType: file.type,
          size: file.size,
          name: file.name,
        });
      };
      img.src = URL.createObjectURL(file);
    });
  }

  private static collectSvgMetadata(file: File): MediaMetadata {
    return {
      type: "vector",
      mimeType: file.type,
      size: file.size,
      name: file.name,
    };
  }

  private static collectVideoMetadata(file: File): Promise<MediaMetadata> {
    return new Promise(resolve => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        resolve({
          type: "video",
          mimeType: file.type,
          size: file.size,
          width: video.videoWidth,
          height: video.videoHeight,
          name: file.name,
        });
        URL.revokeObjectURL(video.src);
      };
      video.onerror = () => {
        resolve({
          type: "video",
          mimeType: file.type,
          size: file.size,
          name: file.name,
        });
      };
      video.src = URL.createObjectURL(file);
      video.load();
    });
  }

  private static collectBasicMetadata(
    file: File,
    type: MediaType
  ): MediaMetadata {
    return {
      type,
      mimeType: file.type,
      size: file.size,
      name: file.name,
    };
  }
}
